<template>
  <fieldset>
    <el-divider>Mail Options</el-divider>
    <div class="row mb-30">
      <div class="col-sm-6 checkbox-container">
        <el-checkbox
          id="noMail"
          v-model="modelValue.noMail"
        >
          Do not send me transaction mail
        </el-checkbox>
        <div class="help-block">
          Note that if this option is enabled, the user will not get any transaction mail
        </div>
      </div>
    </div>

    <div
      class="row mb-0"
      :class="{ 'disabled-container': modelValue.noMail }"
    >
      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="monthlyInvoiceMail"
          v-model="modelValue.monthlyInvoiceMail"
        >
          Monthly Invoice Mail
        </el-checkbox>
      </div>
    </div>

    <div class="row mt-30 mb-30">
      <div class="col-sm-6 checkbox-container">
        <el-checkbox
          id="doNotSendMarketingMail"
          v-model="modelValue.doNotSendMarketingMail"
        >
          Do not send me marketing mail
        </el-checkbox>
        <div class="help-block">
          Note that if this option is enabled, the user will not get any marketing mail!
        </div>
      </div>
    </div>

    <div
      class="row mb-0"
      :class="{ 'disabled-container': modelValue.doNotSendMarketingMail }"
    >
      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="gourmetRestaurantsMail"
          v-model="modelValue.gourmetRestaurantsMail"
        >
          Gourmet Restaurants Mail
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="reactivationPostcardsMail"
          v-model="modelValue.reactivationPostcardsMail"
        >
          Reactivation Postcards Mail
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="happyBirthdayPostcardsMail"
          v-model="modelValue.happyBirthdayPostcardsMail"
        >
          Happy Birthday Postcards Mail
        </el-checkbox>
      </div>
    </div>
  </fieldset>
</template>

<script setup lang="ts">
defineProps({
  modelValue: {
    type: Object,
    required: true,
  },
});
</script>
